import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { pageView } from '../analytics'

/**
 * Sends a GA4 page_view on every client-side navigation (SPA).
 */
export default function AnalyticsRouteListener() {
  const location = useLocation()

  useEffect(() => {
    const path = `${location.pathname}${location.search}`
    pageView(path)
  }, [location.pathname, location.search])

  return null
}
